<div class="Flexbox flex-wrap-wrap data-table full-width">
  <div class="data-table_header-column" *ngFor="let column of  this.configuration.columns;let i = index"
       [style.grid-column]="i + 1" translate>{{translationPrefix + '.' + column.name}}</div>
  <div class="data-table_value" *ngFor="let columnData of columnsData"
       [style.grid-row]="columnData.row" [style.grid-column]="columnData.column">
    <div [ngSwitch]="columnData.type">
      <color-box *ngSwitchCase="'color-box'" [text]="columnData.value" [config]="columnData.config"></color-box>
      <color-text *ngSwitchCase="'color-text'" [text]="columnData.value" [config]="columnData.config"></color-text>
      <div *ngSwitchDefault>{{columnData.value}}</div>
    </div>
  </div>
</div>
